module.exports = __webpack_public_path__ + "img/img10.c536d9be.png";